import React, { useEffect, useState } from "react";
import * as dt from "../../data";
import "./tech.css";

export const Technology = ({ name }) => {
  const def = "Launch vehicle";
  const { technology } = dt.default;
  console.log("dt.default", dt.default);
  const [tech, setTech] = useState(() =>
    technology.find((i) => i.name === def)
  );
  console.log("tech", tech);

  const selectTech = (t) => {
    setTech(technology.find((item) => item.name === t));
  };
  useEffect(() => {
    debugger;

    document.body.classList = "technology";
    selectTech(def);
  }, []);
  return (
    <main id="main" class="grid-container grid-container--technology">
      <h1 class="numbered-title title">
        <span aria-hidden="true">03</span> space launch 101
      </h1>
      <picture>
        <source
          media="(min-width:45rem)"
          srcset={tech.images.portrait}></source>
        <img src={tech.images.landscape} alt={tech.name} />
      </picture>
      <div className="num-indecators flex flex-row">
        {technology.map((t, i) => {
          return (
            <button
              onClick={() => selectTech(t.name)}
              style={{ borderRadius: "50%", height: "4rem", width: "4rem" }}
              className="medium-button  ff-serif fs-600 text-dark bg-white">
              {i + 1}
            </button>
          );
        })}
      </div>
      <div className="technology-details">
        <h2 className="fs-600 uppercase ff-serif">{tech.name}</h2>
        <p className="fs-300  --ff-sans-normal">{tech.description}</p>
      </div>
    </main>
  );
};
